module.exports = __webpack_public_path__ + "2e361b6b0679a65e43b872caa03dd570.fbx";